const ACTIVE_COMPOSITE_ITEM = "data-composite-item-active";
export {
  ACTIVE_COMPOSITE_ITEM
};
//# sourceMappingURL=constants.js.map
